/**
 * Immich 写真グループカード
 *
 * 近接時刻 (デフォルト 15 分以内) で撮影された写真をまとめて、
 * サムネイルストリップとして表示する。
 */

import { Camera } from 'lucide-react'

import type { ImmichAsset } from '@/api/services/immich'
import { formatTimeJST } from '@/lib/activity-format-utils'
import { cn } from '@/lib/utils'

import { PhotoGrid } from './photo-grid'

type Props = {
  assets: ImmichAsset[]
  className?: string
}

export const PhotoGroupCard = ({ assets, className }: Props) => {
  if (assets.length === 0) return null

  const first = assets[0]
  const last = assets[assets.length - 1]
  const startLabel = formatTimeJST(first?.fileCreatedAt ?? null)
  const endLabel = formatTimeJST(last?.fileCreatedAt ?? null)
  const rangeLabel = assets.length > 1 && startLabel !== endLabel ? `${startLabel}〜${endLabel}` : startLabel

  return (
    <div className={cn('rounded-lg border bg-card p-3 shadow-sm', className)}>
      <div className="flex items-center justify-between gap-2 mb-2">
        <div className="flex items-center gap-2 min-w-0">
          <div className="rounded-lg p-2 bg-sky-500/10">
            <Camera className="size-5 text-sky-500" />
          </div>
          <div className="min-w-0">
            <h3 className="text-sm font-medium truncate">写真 {assets.length} 枚</h3>
            <p className="text-xs text-muted-foreground truncate">{rangeLabel}</p>
          </div>
        </div>
      </div>

      <PhotoGrid assets={assets} />
    </div>
  )
}
